// ============================================================================
// LOS DESTINOS DEL MENÚ — en su propio módulo para poder medirlos sin montar el
// Shell (T-ENT-5, V-213). El Shell los pinta; aquí solo se declaran.
// ============================================================================
import {
  AlarmClock, BarChart3, GraduationCap, KanbanSquare, Megaphone, MessageSquare,
  TestTubeDiagonal, Users, UserCog,
} from "lucide-react";

export const DESTINOS = [
  { a: "/", t: "Conversaciones", corto: "Chats", I: MessageSquare },
  { a: "/seguimientos", t: "Seguimientos", corto: "Seguir", I: AlarmClock },
  { a: "/contactos", t: "Contactos", corto: "Gente", I: Users },
  { a: "/embudo", t: "Embudo", corto: "Embudo", I: KanbanSquare },
  { a: "/metricas", t: "Métricas", corto: "Números", I: BarChart3 },
  { a: "/campanias", t: "Campañas", corto: "Campañas", I: Megaphone, soloEscritorio: true },
  { a: "/probar", t: "Probar bot", corto: "Probar", I: TestTubeDiagonal, soloEscritorio: true },
  // T-ENT-5 · EL ENTRENAMIENTO ES UN SOLO DESTINO (R-ENT-01). Antes eran cinco
  // (Ajustes · Conocimiento · Guion · Precios · Catálogo), cada uno con su
  // icono; ahora viven como pestañas dentro de `/entrenamiento`, y las cinco
  // URL viejas redirigen. `soloEscritorio` por el criterio de siempre: se
  // configura sentado, no en el celular atendiendo.
  { a: "/entrenamiento", t: "Entrenamiento del bot", corto: "Entrenar", I: GraduationCap, soloEscritorio: true },
  // Equipo: administración pura (se toca cuando entra o sale alguien), así que
  // no compite por un sitio en la barra del celular. Solo lo ve el dueño — la
  // propia pantalla lo comprueba, y la base también.
  { a: "/equipo", t: "Equipo", corto: "Equipo", I: UserCog, soloEscritorio: true, soloDueno: true },
];
